<script setup lang="ts">
import type { BreadcrumbItem } from '@@/shared/application';
import type { IadLink } from '~/composables/links-builder';

const props = defineProps<{
  item: BreadcrumbItem
  textTag: 'h1' | 'span'
}>();

const link = computed<IadLink>(() => {
  if (props.item.to) return props.item;
  return { tag: props.textTag };
});
const { linkComponent, linkBindings } = useLinksBuilder(link);
</script>

<template>
  <component
    :is="linkComponent"
    v-bind="linkBindings"
    class="text-sm inline
    before:content-['_>_'] first:before:content-none before:inline-block before:px-[6px]
    hover:underline last:hover:no-underline last:cursor-text
    "
  >
    {{ item.text }}
  </component>
</template>
